module.exports = {
  // format: (d) => {
  //   return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
  // }
  getToday() {
    const d = new Date()
    const today = `${d.getFullYear()}-${d.getMonth() + 1}-${ d.getDate()}`
    return today
  },
  /**
   * 计算百分比
   * @param {*} num 当前数
   * @param {*} total  总数
   * @returns 
   */
  getPercent(num, total) {
      num = parseFloat(num)
      total = parseFloat(total)
      if (isNaN(num) || isNaN(total)) {
        return 0 // '-'
      }
      return total <= 0 ? "0%" : (Math.round(num / total * 10000) / 100.00)+"%";
  },
  // 等分数组
  groupArray(array, subGroupLength) {
    let index = 0;
    let newArray = [];
    while(index < array.length) {
      let childArr = array.slice(index, index += subGroupLength)
      if (childArr.length < subGroupLength){
          var len= subGroupLength - childArr.length
          for (let i=0; i<len; i++) {
            childArr.push({})
          }
      }
      newArray.push(childArr)
    }
    return newArray
  },
  // 进入全屏
  requestFullScreen(target) {
    const $dome = target || document.documentElement
    if ($dome.requestFullscreen) {
      $dome.requestFullscreen()
    } else if ($dome.msRequestFullscreen) {
      $dome.msRequestFullscreen()
    } else if ($dome.mozRequestFullScreen) {
      $dome.mozRequestFullScreen()
    } else if ($dome.webkitRequestFullScreen) {
      $dome.webkitRequestFullScreen()
    }
  },
  // 退出全屏
  exitFullscreen() {
    const $dome = document
    if ($dome.exitFullscreen) {
      $dome.exitFullscreen()
    } else if ($dome.mozCancelFullScreen) {
      $dome.mozCancelFullScreen()
    } else if ($dome.webkitCancelFullScreen) {
      $dome.webkitCancelFullScreen()
    }
  },
  // 检测是否退出全屏
  checkIsFullScreen() {
    const isFullScreen =
      document.fullscreen ||
      document.mozFullScreen ||
      document.webkitIsFullScreen
    return isFullScreen == undefined ? false : isFullScreen
  },
  format: (d) => {
    return (d.getMonth() + 1) + '' + d.getDate() + '-' + d.getHours() + d.getMinutes();
  },
  getQueryVariable(variable) {
    const query = window.location.search.substring(1)
    const vars = query.split("&")
    for (let i=0; i<vars.length; i++) {
      let pair = vars[i].split("=")
      if(pair[0] == variable){
        return pair[1]
      }
    }
    return false
  },
  // 可以和上面方法合并
  getQueryParams() {
    let theRequest = new Object()
    const query = window.location.search.substring(1)
    if (query) {
      let arr = query.split('&')
      for (let i = 0; i < arr.length; i++) {
        let key = arr[i].substring(0, arr[i].indexOf("="))
        let val = arr[i].substring(arr[i].indexOf("=") + 1)
        theRequest[key] = val
      }
    }
    return theRequest
  }
}